var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._l(_vm.items, function (item, i) {
        return _c(
          "w-row",
          { key: i },
          [
            _c(
              "w-col",
              { attrs: { xs: "12", md: "6" } },
              [
                _c("w-input", {
                  attrs: {
                    label: _vm.$ct("label"),
                    value: item.text,
                    fancy: "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.onTextInput(i, $event)
                    },
                  },
                }),
              ],
              1
            ),
            _c("w-col", { attrs: { xs: "12", md: "6" } }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("value"),
                      value: item.value,
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onValueInput(i, $event)
                      },
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("remove-option"),
                          expression: "$ct('remove-option')",
                        },
                      ],
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.onValueRemove(i)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "trash" } })],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        )
      }),
      _c(
        "w-row",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("add-option"),
                  expression: "$ct('add-option')",
                },
              ],
              attrs: { round: "" },
              on: {
                click: function ($event) {
                  return _vm.onValueAdd()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "plus" } })],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }